<template>
  <transition name="bounce" appear>
    <h1>NOT FOUND PAGE</h1>
  </transition>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>
